export default function Footer() {
  return <footer className="py-10 text-center">Trade app ©2022</footer>;
}
